import { SYS_BREAKPOINT_MD, SYS_BREAKPOINT_SM } from '@oneaudi/unified-web-common';
import { useEffect, useState } from 'react';

export const useWindowSize = (): {
  height: number;
  width: number;
} => {
  const [state, setState] = useState({
    height: typeof window !== 'undefined' ? window.innerHeight : +SYS_BREAKPOINT_MD,
    width: typeof window !== 'undefined' ? window.innerWidth : +SYS_BREAKPOINT_SM,
  });

  useEffect(() => {
    function handleResize(): void {
      setState({
        height: typeof window !== 'undefined' ? window.innerHeight : +SYS_BREAKPOINT_MD,
        width: typeof window !== 'undefined' ? window.innerWidth : +SYS_BREAKPOINT_SM,
      });
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
      return (): void => {
        window.removeEventListener('resize', handleResize);
      };
    }

    return (): void => {};
  }, []);

  return state;
};
